




























import {
  Prop,
  Vue,
  Component
} from "@/shared/vuepack";
import { FetchState, EbtoTransferStep } from "@/shared/types";
import * as _ from "lodash";


@Component
export default class TransferStepsWidget extends Vue {

  @Prop({required: false, default: EbtoTransferStep.Provider})
  currentStep: EbtoTransferStep;

  EbtoTransferStep = EbtoTransferStep;
}
